export default __webpack_public_path__ + "static/media/jacobcrew.db547f8f.jpg";